module.exports = __webpack_public_path__ + "img/McLaren_Render_x2.3959c59.png";